var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "log-in-03"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.5 16.9998C6.5 17.3511 6.5 17.5268 6.51567 17.6795C6.64575 18.9473 7.5626 19.9945 8.80206 20.291C8.95134 20.3267 9.1255 20.3499 9.47368 20.3963L16.0656 21.2753C17.942 21.5254 18.8803 21.6505 19.6084 21.361C20.2478 21.1068 20.7803 20.6406 21.1168 20.0405C21.5 19.3569 21.5 18.4104 21.5 16.5174V7.48232C21.5 5.58928 21.5 4.64275 21.1168 3.95923C20.7803 3.35911 20.2478 2.89288 19.6084 2.63868C18.8803 2.34914 17.942 2.47423 16.0656 2.72442L9.47368 3.60335C9.12546 3.64978 8.95135 3.67299 8.80206 3.7087C7.5626 4.0052 6.64575 5.05241 6.51567 6.32018C6.5 6.47288 6.5 6.64854 6.5 6.99984M12.5 7.99984L16.5 11.9998M16.5 11.9998L12.5 15.9998M16.5 11.9998H3.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogin);
export default __webpack_public_path__ + "static/media/icon_login.970754423a247d149927694c92b9f24d.svg";
export { ForwardRef as ReactComponent };